var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal modal--trade modal-trade"},[_c('form-trade',{attrs:{"trade":_vm.trade},on:{"close":function($event){return _vm.$emit('close')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }